/** Colored circle markers — no external PNG assets required. */
export function circleMarkerIcon(
  fillColor: string,
  scale = 11
): google.maps.Symbol | undefined {
  if (typeof window === 'undefined' || !window.google?.maps) return undefined;
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor,
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    scale,
  };
}

export const PICKUP_MARKER_ICON = () => circleMarkerIcon('#22C55E', 12);
export const DROP_MARKER_ICON = () => circleMarkerIcon('#EF4444', 12);
export const AMBULANCE_MARKER_ICON = () => circleMarkerIcon('#F97316', 14);
